export const API_METRICS_NAME = 'ApiMetrics';

export const API_END_POINTS = {
  INCREMENT_QUERY: '/query',
  INCREMENT_ERROR: '/error',
  INCREMENT_TIMEOUT: '/timeout',
  STORE_RESPONSE_TIME: '/response-time',
  INCREMENT_QUERY_CUSTOM: '/query-custom',
};



// WEBPACK FOOTER //
// ./app/sdk/metrics/apiMetricsConstants.js